import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../Containers/Config/index.js';
import { GET_GLOBAL_METRICES, GET_GLOBAL_METRICES_ERROR, GET_GLOBAL_METRICES_SUCCESS } from '../../../actionType.js';
import apiCall from '../../../apiCall.js';

function* getGlobalMetrices({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/metrics/global`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParam,
    });

    if (response.status === 200) {
      yield put({
        type: GET_GLOBAL_METRICES_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_GLOBAL_METRICES_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_GLOBAL_METRICES_ERROR, payload: error });
  }
}

export function* watchGetGlobalMetrices() {
  yield takeEvery(GET_GLOBAL_METRICES, getGlobalMetrices);
}

function* getGlobalMetricesSaga() {
  yield all([fork(watchGetGlobalMetrices)]);
}

export default getGlobalMetricesSaga;
